import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MdSnackBar } from '@angular/material';

import { TdDialogService, TdLoadingService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';

import 'rxjs/add/operator/toPromise';

@Component({
  selector: 'sorter-form',
  providers: [StorageService],
  templateUrl: './formConfig.component.html',
  styleUrls: ['./formConfig.component.scss'],
})
export class SorterConfigFormComponent implements OnInit {

  action: string;
  prio: number;
  config: any = {};

  chipAddition: boolean = true;
  chipRemoval: boolean = true;

  private storage: any = null;
  private order: any = null;
  private mogid: string;
  storages: any[];
 
  constructor(private _storageService: StorageService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _snackBarService: MdSnackBar,
              private _loadingService: TdLoadingService,
              private _dialogService: TdDialogService) {}

              
  goBack(): void {
    this._router.navigate(['/sorter']);
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: {prio: number}) => {
      this.prio = params.prio;
      if (this.prio) {
        this.load();
      }
    });
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('sorterconfig.form');
      this.config = await this._storageService.getSorterConfig(this.prio).toPromise();
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error loading the sorter config'});
    } finally {
      this._loadingService.resolve('sorterconfig.form');
    }
  }


  async save(): Promise<void> {
    try {
      this._loadingService.register('sorterconfig.form');    
      await this._storageService.updateOrCreateSorterConfig(this.config.prio, this.config.channel, this.config.projectId, this.config.routingInformation, this.config.storageStatus).toPromise();
      this.goBack();
    } catch (error) {
      this._dialogService.openAlert({title: 'There was an error saving the config', message: error.message});
    } finally {
      this._loadingService.resolve('sorterconfig.form');
    }
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/sorter/formConfig/formConfig.component.ts